import classNames from 'classnames';
import { SectionTitle, TextBlock, Button } from '@/ui/index';
import { ServiceLogoBg, ArrowRight } from '@/icons/index';
import { useBusiness } from '@/hooks/useBusiness';

import styles from './ServiceReverse.module.scss';

const ServiceReverse = ({
  data,
  className,
  dark = false,
  background = false,
}) => {
  const isBusiness = useBusiness();

  const renderReverseItem = (item, index) => {
    return (
      <article
        className={classNames(styles['reverse-item'], {
          [styles.business]: isBusiness,
        })}
        key={index}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <div className={styles['reverse-item__content']}>
          {item?.top_text && (
            <span className={styles['reverse-item__category']}>
              {item.top_text}
            </span>
          )}
          {item?.title && (
            <SectionTitle
              titleModify={classNames(
                styles['reverse-item__title'],
                'title--medium',
              )}
              icon={item?.icon}
            >
              {item.title}
            </SectionTitle>
          )}
          {item?.content && (
            <TextBlock className={styles.description}>
              <div dangerouslySetInnerHTML={{ __html: item.content }} />
              {item?.button_text && (item?.slug || item?.external_link) && (
                <Button
                  Component={item?.external_link ? 'a' : 'router'}
                  size={'normal'}
                  className={styles.services_button}
                  href={item?.external_link ?? item?.slug}
                  hasTarget={Boolean(item?.external_link)}
                >
                  {item.button_text} <ArrowRight width={24} />
                </Button>
              )}
            </TextBlock>
          )}
        </div>
        {item?.image && (
          <div
            className={classNames(styles['reverse-item__img-wrap'], {
              [styles.dark]: dark,
              [styles.background]: !background,
            })}
          >
            <div
              className={styles['reverse-item__img']}
              style={{
                backgroundImage: `url("${item.image}")`,
              }}
            ></div>

            {Boolean(background) && (
              <ServiceLogoBg className={styles['reverse-item__bg']} />
            )}
          </div>
        )}
      </article>
    );
  };

  return (
    <section
      className={classNames(styles['service-reverse'], className)}
      itemScope
      itemType='https://schema.org/Service'
    >
      {data?.text && (
        <SectionTitle
          className={styles['service-reverse__title']}
          isHtml
          icon={data?.icon}
        >
          {data.text}
        </SectionTitle>
      )}
      {data?.items?.length > 0 && (
        <div className={styles['service-reverse__inner']}>
          {data.items.map(renderReverseItem)}
        </div>
      )}
    </section>
  );
};

export default ServiceReverse;
